module.exports = __webpack_public_path__ + "static/media/instant-pages.fd951b12.svg";